import Vue from 'vue';
export const filterEventBus = new Vue();
